import enAuth from '../dictionaries/en/auth.json' with { type: 'json' };
import enBin from '../dictionaries/en/bin.json' with { type: 'json' };
import enCapture from '../dictionaries/en/capture.json' with { type: 'json' };
import enCategories from '../dictionaries/en/categories.json' with { type: 'json' };
import enCommon from '../dictionaries/en/common.json' with { type: 'json' };
import enErrors from '../dictionaries/en/errors.json' with { type: 'json' };
import enNavigation from '../dictionaries/en/navigation.json' with { type: 'json' };
import enNotes from '../dictionaries/en/notes.json' with { type: 'json' };
import enSearch from '../dictionaries/en/search.json' with { type: 'json' };
import enSettings from '../dictionaries/en/settings.json' with { type: 'json' };
import esAuth from '../dictionaries/es/auth.json' with { type: 'json' };
import esBin from '../dictionaries/es/bin.json' with { type: 'json' };
import esCapture from '../dictionaries/es/capture.json' with { type: 'json' };
import esCategories from '../dictionaries/es/categories.json' with { type: 'json' };
import esCommon from '../dictionaries/es/common.json' with { type: 'json' };
import esErrors from '../dictionaries/es/errors.json' with { type: 'json' };
import esNavigation from '../dictionaries/es/navigation.json' with { type: 'json' };
import esNotes from '../dictionaries/es/notes.json' with { type: 'json' };
import esSearch from '../dictionaries/es/search.json' with { type: 'json' };
import esSettings from '../dictionaries/es/settings.json' with { type: 'json' };
import type { Locale } from './constants.js';
import type { Dictionary, Messages, Namespace } from './types.js';

const dictionaries: Record<Locale, Dictionary> = {
    en: {
        common: enCommon as Messages,
        auth: enAuth as Messages,
        navigation: enNavigation as Messages,
        capture: enCapture as Messages,
        notes: enNotes as Messages,
        search: enSearch as Messages,
        categories: enCategories as Messages,
        settings: enSettings as Messages,
        bin: enBin as Messages,
        errors: enErrors as Messages,
    },
    es: {
        common: esCommon as Messages,
        auth: esAuth as Messages,
        navigation: esNavigation as Messages,
        capture: esCapture as Messages,
        notes: esNotes as Messages,
        search: esSearch as Messages,
        categories: esCategories as Messages,
        settings: esSettings as Messages,
        bin: esBin as Messages,
        errors: esErrors as Messages,
    },
};

export function getDictionary<const T extends readonly Namespace[]>(
    locale: Locale,
    namespaces: T,
): Pick<Dictionary, T[number]> {
    const dictionary = dictionaries[locale];

    const result: Partial<Dictionary> = {};

    for (const namespace of namespaces) {
        result[namespace] = dictionary[namespace];
    }

    return result as Pick<Dictionary, T[number]>;
}

export function getFullDictionary(locale: Locale): Dictionary {
    return dictionaries[locale];
}
